import { useTranslation } from 'next-i18next';
import { Dispatch, SetStateAction } from 'react';
import { useSession } from 'next-auth/react';
import Button from '@components/Button/Button';
import LayoutUiState from '@features/layout/mobX/LayoutUiState';
import { useUserPanelStore } from '@features/userPanel/mobx/providers/UserPanelStoreProvider';
import { NAVIGATION_ITEMS } from '@features/userPanel/const';
import styles from '@components/CreativeModalContent/CreativeModalSummary.style';
type PropsType = {
  setValueModal: Dispatch<SetStateAction<boolean>>;
};
const CreativeModalSummary = ({
  setValueModal
}: PropsType) => {
  const {
    setNavigationProductItemSelected,
    setMenuPined,
    setUserData,
    setMenuMobileOpened
  } = LayoutUiState;
  const {
    data: session
  } = useSession();
  const {
    setUserPanelItem
  } = useUserPanelStore();
  const openUserPanel = () => {
    setMenuMobileOpened(true);
    setNavigationProductItemSelected(null);
    setMenuPined(true);
    setUserData(session || true);
    setUserPanelItem(NAVIGATION_ITEMS[4]);
    setValueModal(false);
  };
  const {
    t
  } = useTranslation('common');
  return <div sx={styles.creativeModal}>
      <p>{t('creative.modal.summary')}</p>
      <div sx={styles.buttonsContainer}>
        <Button size="small" variant="default" variantColor="dark" onClick={() => openUserPanel()}>
          {t('creative.modal.button.show_projects')}
        </Button>
        <Button size="small" variant="outlined" onClick={() => setValueModal(false)}>
          {t('creative.modal.button.close')}
        </Button>
      </div>
    </div>;
};
export default CreativeModalSummary;